import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import { useAuth } from '../hooks/useAuth';

// Route-level guard for the whole /platform/* area, mirroring PermissionRoute's
// in-place "access denied" (not a redirect) so a direct URL hit explains why.
export default function PlatformOwnerRoute() {
  const { user } = useAuth();

  if (!user?.isPlatformOwner) {
    return (
      <Box sx={{ textAlign: 'center', py: 10 }}>
        <LockRoundedIcon sx={{ fontSize: 40, color: 'text.secondary', mb: 1.5 }} />
        <Typography variant="h6">You don't have access to this page</Typography>
        <Typography variant="body2" color="text.secondary" mt={0.5}>
          Platform Admin is only available to platform owners.
        </Typography>
      </Box>
    );
  }

  return <Outlet />;
}
